import React, { useState } from "react";
import appContext from "../../appContext";
import { useMediaQuery } from "@mui/material";
import { ReactComponent as WaymoreLogo } from "../../assets/waymore.svg";
import { Tooltip } from "@material-ui/core";

import {
  HeaderContainer,
  HeaderInnerGrid,
  HeaderLogoActionsContainer,
  HeaderTitleContainer,
  HeaderActionButtonsContainer,
  HeaderLogoTextContainer,
  HeadingText,
  HeaderImageContainer,
  HeaderSaveDeleteContainer,
  HeaderAvatarContainer,
  ExitContainer,
} from "./styled";

import {
  DeleteButton,
  ExitButton,
  FormLinkButton,
  PreviewButton,
  PublishButton,
  SaveChangesButton,
  SecondaryButton,
  SettingsButton,
  ShareButton,
} from "../../components/Custom/Buttons";
import { conversationalFormsURL } from "../../Utils/common";
import DeleteConfirmationModal from "../../components/Custom/Modals/DeleteConfirmationModal";

export default function FormHeader({
  title,
  isNewForm,
  onSettingsClick,
  onDeleteClick,
  onPreviewClick,
  onSaveClick,
  isPublished,
  disableIsPublished,
  type,
  onShareClick,
  formUUID
}: any) {
  const isLessThan1500 = useMediaQuery("(max-width:1500px)");
  const { setOpenLogicDialog, currentFormtitle, setTriggerRemoveLogic } = React.useContext(appContext);
  const [isOpenRemoveLogic, setIsOpenRemoveLogic] = useState(false)

  const onExitClick = () => {
    setOpenLogicDialog(false);
  };

  const handleOpenForm = () => {
    if (formUUID) {
      window.open(`${conversationalFormsURL}?id=${formUUID}`, '_blank')?.focus();
    }
  }

  return (
    <HeaderContainer>
      <HeaderInnerGrid container>
        <HeaderLogoActionsContainer item xs={4.2}>
          <HeaderLogoTextContainer>
            <HeaderImageContainer>
              <WaymoreLogo />
            </HeaderImageContainer>
            {!isLessThan1500 && (
              <HeadingText>Conversational Form Builder</HeadingText>
            )}
          </HeaderLogoTextContainer>
          {type !== "logic" && (
            <HeaderSaveDeleteContainer>
              <SettingsButton onClick={onSettingsClick} />
              <DeleteButton disabled={isNewForm} onClick={onDeleteClick} />
            </HeaderSaveDeleteContainer>
          )}
        </HeaderLogoActionsContainer>
        <HeaderTitleContainer item xs={3.4}>
          {type !== "logic" ? (
          <Tooltip title={title ? title : "My New Conversational Form"} arrow>
            <HeadingText>
              {title ? title : "My New Conversational Form"}
            </HeadingText>
          </Tooltip>
          ) : (
          <HeadingText>{`${currentFormtitle} > Logics`}</HeadingText>
          )}
        </HeaderTitleContainer>
        {type !== "logic" ? (
          <HeaderActionButtonsContainer item xs={4.4}>
            <FormLinkButton onClick={handleOpenForm} disabled={!formUUID || !isPublished} />
            <PreviewButton onClick={onPreviewClick} />
            <ShareButton onClick={onShareClick} disabled={!formUUID || !isPublished} />
            <SaveChangesButton onClick={() => onSaveClick("save")} />
            <PublishButton
              isPublished={isPublished}
              disabled={isNewForm && disableIsPublished}
              onClick={() => onSaveClick(isPublished ? "unPublish" : "publish")}
            />
            <HeaderAvatarContainer src="/broken-image.jpg" />
          </HeaderActionButtonsContainer>
        ) : (
          <ExitContainer item xs={4} gap={2}>
            <SecondaryButton onClick={() => setIsOpenRemoveLogic(true)} >
              Remove Logic
            </SecondaryButton>
            <ExitButton onClick={onExitClick} />
          </ExitContainer>
        )}
      </HeaderInnerGrid>
      <DeleteConfirmationModal
        isOpen={isOpenRemoveLogic}
        cancelHandler={() => setIsOpenRemoveLogic(false)}
        submitText="Remove Logic"
        contentText={`Are you sure you want to Remove Logic?`}
        SecondaryText={"This action cannot be undone"}
        submitHandler={() => { setTriggerRemoveLogic(true); setIsOpenRemoveLogic(false) }}
      />
    </HeaderContainer>
  );
}
